'use client';

/**
 * Stand der Darstellung beim Server-Rendern — für `anfang` der Fundament-Schalter.
 *
 * Die Wahl hält der Cookie ein Jahr (`shared/Darstellung.tsx`), das Root-Layout setzt
 * `data-theme` daraus schon ins erste HTML. Der Schalter selbst kann den Cookie beim
 * Server-Rendern nicht lesen; ohne diesen Stand zeichnete er bei einem Wiederbesuch im
 * Dunkeln erst den Mond und sprang beim Hydrieren zur Sonne — die Seite sah aus, als
 * hätte sie die Wahl vergessen.
 */
import { createContext, useContext, type ReactNode } from 'react';

const DarstellungAnfangKontext = createContext(false);

export function DarstellungAnfang({ dunkel, children }: { dunkel: boolean; children: ReactNode }) {
  return <DarstellungAnfangKontext.Provider value={dunkel}>{children}</DarstellungAnfangKontext.Provider>;
}

export function useDarstellungAnfang(): boolean {
  return useContext(DarstellungAnfangKontext);
}
